/**
 * @generated SignedSource<<603c1f40eb39f8ee51e8b73cb1cd78ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubAssetClassWidget_data$data = {
  readonly getAssetAllocationByAssetClass: ReadonlyArray<{
    readonly assetClassName: string;
    readonly marketValue: any;
  }>;
  readonly getTopSubAssetClasses: {
    readonly assetClassTotal: any;
    readonly subClasses: ReadonlyArray<{
      readonly subAssetClassMarketValue: any;
      readonly subAssetClassName: string;
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "SubAssetClassWidget_data";
};
export type SubAssetClassWidget_data$key = {
  readonly " $data"?: SubAssetClassWidget_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubAssetClassWidget_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input2"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubAssetClassWidget_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input2"
        }
      ],
      "concreteType": "AssetAllocationByAssetClassModel",
      "kind": "LinkedField",
      "name": "getAssetAllocationByAssetClass",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assetClassName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "marketValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "GetTopSubAssetClassesModel",
      "kind": "LinkedField",
      "name": "getTopSubAssetClasses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assetClassTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TopSubAssetClassModel",
          "kind": "LinkedField",
          "name": "subClasses",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subAssetClassMarketValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subAssetClassName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ClientSummaryViewer",
  "abstractKey": null
};

(node as any).hash = "baaac3903aacb43707595e454c661b30";

export default node;
